import { Factory } from 'rosie';

Factory.define('AvailableLanguage').attr('name', 'AVAILABLE_LANGUAGE');

Factory.define('AvailableLanguageWithDefaults')
  .extend('AvailableLanguage')
  .attr('id', 'en-us');
